import { createReducer } from 'redux-create-reducer';
import camelize from 'camelcase-keys-deep';

import { BATCH_FETCHING, BATCH_FETCHED, BATCH_FETCHED_ERROR } from '../actions';

const initialState = {
  loading: false,
  batch: null,
  repairs: [],
};

const events = {
  [BATCH_FETCHED]: (state, { batch, repairs }) => {
    return {
      ...state,
      batch,
      repairs: camelize(repairs),
      loading: false,
    };
  },

  [BATCH_FETCHED_ERROR]: state => ({ ...state, loading: false }),

  [BATCH_FETCHING]: state => ({ ...state, loading: true }),
};

export default createReducer(initialState, events);
